import { Download, Info } from "react-feather";
import { Link } from "react-router-dom";
import {
  ButtonGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { formatDateFromString } from "../../../Utils/externalFunctions";
import { getDarkDropdown } from "../../../Utils/otherFunctions";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import DateSortFunction from "../../DataTableComponents/DateSortFunction";
import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";
import { getItemCreateSuccessMsg } from "../../../Constant/Message";

const getTandaTerimaColumns = ({ themeContext, handleEditTandaTerima, axiosInstance }) => {

  const handleCetakTandaTerima = async (id) => {
    try {
      const res = await axiosInstance.get(`transaksi/tandaterima/cetak/${id}`, {
        responseType: "blob",
      });
      const file = new Blob([res.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const newTab = window.open(fileURL, "_blank");
      if (!newTab) {
        console.error("Popup blocked. Please allow popups for this website.");
      }
      URL.revokeObjectURL(fileURL);
      toast.success(getItemCreateSuccessMsg("Tanda Terima"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    } catch (e) {
      console.error(e);
    }
  }

  return [
    {
      name: <DataTableTitle text={"Tanggal Transaksi"} />,
      selector: (row) => formatDateFromString(row.tgl),
      sortable: true,
      sortFunction: DateSortFunction("tgl", "string"),
    },
    {
      name: <DataTableTitle text={"Kode"} />,
      selector: (row) => row.kode_group_dokumen,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Diajukan Oleh"} />,
      selector: (row) => row.diajukan_oleh,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"PIC Keuangan"} />,
      selector: (row) => row.username_pic_keuangan,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => (
        <ButtonGroup>
          <UncontrolledDropdown>
            <DropdownToggle caret></DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                className={`d-flex align-items-center gap-2 ${getDarkDropdown(
                  themeContext
                )}`}
                onClick={() => handleEditTandaTerima(row)}
              >
                <Info size={12} />
                Rincian Tanda Terima
              </DropdownItem>
              <DropdownItem divider />
              {/* <DropdownItem className={`d-flex align-items-center gap-2 ${getDarkDropdown(themeContext)}`} onClick={() => handleCetakTandaTerima(row.id)}>
                <Download size={12} />
                Cetak Tanda Terima
              </DropdownItem> */}
              <DropdownItem className={getDarkDropdown(themeContext)}>
                <Link
                  className={`d-flex align-items-center gap-2`}
                  to={`${process.env.PUBLIC_URL}/groupdokumentransaksi/document/${row.id}`}
                  target="_blank"
                >
                  <Download size={12} />
                  Cetak Tanda Terima
                </Link>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </ButtonGroup>
      ),
    },
  ];
};

export default getTandaTerimaColumns;
